import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'moeda',
})
export class MoedaPipe implements PipeTransform {
  transform(value: any, ...args) {
    if(value){
      const currencyValue = Number.parseFloat(value);
      return currencyValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/pipes/moeda/moeda.ts